export default __webpack_public_path__ + "static/media/canada-flag-1x.26ce9177.png";